package com.evoapps.evoshift.data.repository

import com.evoapps.evoshift.domain.util.AppClock
import com.evoapps.evoshift.domain.budget.LabourBudget
import com.evoapps.evoshift.domain.repository.LabourBudgetRepository
import com.evoapps.evoshift.data.remote.AppFirestore
import kotlinx.serialization.Serializable

/**
 * `workplaces/{id}/labour_budget/data` (SH-115): employer labour cost per month and, optionally,
 * per week, in the workplace's currency. Absent amounts are off. firestore.rules (validLabourBudget)
 * accept exactly these fields.
 */
@Serializable
internal data class LabourBudgetDto(
    val monthlyAmount: Double? = null,
    val weeklyAmount: Double? = null,
    val updatedAt: String? = null,
    val updatedBy: String? = null
)

internal fun LabourBudgetDto.toDomain() = LabourBudget(monthly = monthlyAmount, weekly = weeklyAmount).normalized()

internal fun LabourBudget.toDto(updatedAt: String, updatedBy: String) =
    normalized().let { LabourBudgetDto(it.monthly, it.weekly, updatedAt, updatedBy) }

class LabourBudgetRepositoryImpl(private val firestore: AppFirestore) : LabourBudgetRepository {
    private fun document(workplaceId: String) =
        firestore.collection("workplaces").document(workplaceId).collection("labour_budget").document("data")

    override suspend fun get(workplaceId: String): Result<LabourBudget> = runCatching {
        val snapshot = document(workplaceId).get()
        if (!snapshot.exists) LabourBudget.OFF else snapshot.data<LabourBudgetDto>().toDomain()
    }

    override suspend fun save(workplaceId: String, budget: LabourBudget, updatedBy: String): Result<Unit> = runCatching {
        document(workplaceId).set(budget.toDto(AppClock.now().toString(), updatedBy))
    }
}
